export const ANIMAL_TYPES = ["Dog", "Cat", "Cow", "Horse", "Pig", "Bird", "Rabbit", "Other"];

export function getAnimalTypeLabel(caseItem) {
  if (caseItem.animal_type === "Other" && caseItem.species_other) return caseItem.species_other;
  return caseItem.animal_type;
}
